// extracted by mini-css-extract-plugin
export default {"skeleton__head":"styles_skeleton__head__4elTT","skeleton__column":"styles_skeleton__column__Wa4pK","table__skeleton":"styles_table__skeleton__FnGQa"};